export default {
  title: 'CRM',
  header: 'Customer Relationship Management',
  lead: {
    header: 'Lead',
    leadList: 'List',
    keywords: 'Keywords',
    create: {
      header: 'Create Lead',
      type: 'Type',
      dateOfContact: 'Date of Contact',
      name: 'English Name',
      phoneNumber: 'Phone Number',
      gender: 'Gender',
      identityCardNo: 'ID Card Number',
      status: 'Status',
      remarks: 'Remarks',
      activityLog: 'Activity Log',
      header: 'Create Lead',
      level: 'Level',
      createTime: 'Create Time',
      updateTime: 'Last Update',
      confirmation: 'Are you sure to create / edit this lead?',
      success: 'Create / Edit success',
      leadLevel: 'Level',

    },
    convertToCustomer: 'Convert Lead to Customer',
    page: 'Page',
    total: 'Total',
    items: 'items',
    search: 'Search',
    dateFrom: 'From',
    dateTo: 'To',
    clear: 'Clear Filters'
  },
  edit: 'Edit',
  customer: {
    header: 'Customer',
    customerList: 'List',
    success: 'Operation Success',
    doubleClick: 'Double click to select a lead',
    importFromLead: 'Import From Lead',
    customerName: 'Customer Name',
    search: 'Search Customer',
    currentAgent: 'Responsible FC',
    edit: 'Edit',
    create: {
      header: 'Create Customer',
      title: 'Title',
      city: 'City',
      country: 'Country',
      nationality: 'Nationality',
      customerType: 'Customer Type',
      customerCode: 'Customer Code',
      englishFirstname: 'English Other Name',
      englishLastname: 'English Surname',
      chineseLastname: 'Chinese Last Name',
      chineseFirstname: 'Chinese Name',
      englishCompanyName: 'English Company Name',
      chineseCompanyName: 'Chinese Company Name',
      identityCardNo: 'ID Card Number',
      brNo: 'BR Number',
      gender: 'Gender',
      dateOfBirth: 'Date of Birth',
      idType: 'ID Type',
      maritalStatus: 'Marital Status',
      contactType: 'Customer Source',
      defaultAddress: 'Default Address',
      nationalityRemarks: 'Nationality Remarks',
      smoker: 'Smoker',
      education: 'Education',
      occupation: 'Occupation',
      nameOfEmployer: 'Name of Employer',
      lengthOfServices: 'Length of Services',
      status: 'Status',
      vulnerable: 'Vulnerable',
      riskLevel: 'Risk Level (AML Risk)',
      telephoneMobile: 'Mobile',
      telephoneHome: 'Home',
      telephoneOffice: 'Office',
      fax: 'Fax',
      email: 'Email',
      chineseResidentialAddress: 'Chinese',
      englishResidentialAddress: 'English',
      chineseCorrespondenceAddress: 'Chinese',
      englishCorrespondenceAddress: 'English',
      correspondenceAddressLeaveBlank: 'Leave blank if Correspondence Address is as same as Residential Address',
      companyCorrespondenceAddressLeaveBlank: 'Leave blank if Correspondence Address is as same as Company Address',
      chineseCompanyAddress: 'Chinese',
      englishCompanyAddress: 'English',
      residentialAddress: 'Residential Address',
      correspondenceAddress: 'Correspondence Address',
      companyAddress: 'Company Address',
      personalHeader: 'User Information',
      userEmail: 'User Email',
      language: 'Language',
      marketingOptOut: 'Marketing Opt-Out',
      generalHeader: 'General Information',
      contactHeader: 'Contact Information',
      customerHeader: 'Customer Information',
      confirmation: 'Are you sure to create customer?',
      header: 'Create Customer',
      success: 'Create / Edit success'
    },
    lifePolicyCount: 'No. of Life Policy',
    generalPolicyCount: 'No. of GI Policy',
    list: {
      lifePolicyCount: '{count} Life Policy',
      generalPolicyCount: '{count} GI Policy'
    },
  },
  calendar: {
    header: 'Calendar',
    appointment: {
      createBtn: 'Create Appointment',
      meetingDate: 'Meeting Date',
      meetingTime: 'Meeting Time',
      meetingAddress: 'Meeting Address',
      address: 'Address',
      event: 'Appointment Event',
      eventPlaceholder: 'Event',
      remarks: 'Remarks',
      customer: 'Customer',
      hour: "Select Hour",
      minute: "Select Minute",
      allDayFlag: 'All Day Event',
    },
    indicator: {
      birthday: 'Birthday',
      life: 'Life Policy',
      gi: 'General Insurance',
      serviceRequest: 'Service Request',
      claim: 'Claim',
      renewal: 'Renewal',
      appointment: 'appointment'
    },
  },
  Notification: {
    header: "Notification",
    more: "View All",
    noContentMsg: 'No Notification Message',
    setAllNotified: 'Set All Notified',
    list: {
      header: 'Notification List',
      category: 'Category',
      from: 'From',
      to: 'To',
      allNotification: 'All Notification',
      unreadNotification: 'Unread Notification',
      readNotification: 'Read  Notification',
      notifiedStatus: '',
      messageType: 'Message Type',
      content: 'Content Message',
      createTime: 'Create Time',
      workFlowStep: 'Workflow Step',
      policyNumber: 'Policy Number',
      policyType: 'policy Type',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      comingBirthday: 'Coming Birthday',
    },
    router: {
      header: 'Notification Router',
    },
    commission: {
      companyCommission: 'Pending Company Commission',
      agentCommission: 'Pending FC Commission',
    },
  },
}



// WEBPACK FOOTER //
// ./src/Crm/langs/en_us/index.js